import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { MatMenu } from '@angular/material/menu';

import { Util } from 'src/shared/util/util';

@Component({
  selector: 'tidy-small-button',
  templateUrl: './small-button.component.html',
  styleUrls: ['./small-button.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class TidySmallButtonComponent {
  @Input() danger = false;
  @Input() disabled = false;
  @Input() iconOnly = false;
  @Input() smallIconButton = false;
  @Input() mediumIconButton = false;
  @Input() image = '';
  /** Keeps the image's own colours (a service icon) instead of tinting it like a glyph. */
  @Input() colorImage = false;
  /** A name whose initials render as the avatar inside the button, in place of an image. */
  @Input() set initials(name: string) {
    this.avatarInitials = this.parseInitials(name);
    this.avatarBackground = this.avatarInitials ? this.util.getAvatarGradient(this.avatarInitials) : '';
  }

  /**
   * The avatar is drawn here rather than with `tidy-initials-icon`: that wraps a
   * Material icon button whose state layer and padding fight a 16px box.
   */
  avatarInitials = '';
  avatarBackground = '';

  constructor(private util: Util) {}

  private parseInitials(name: string): string {
    const words = (name || '').trim().split(/\s+/).filter(Boolean);
    if (words.length === 0) { return ''; }
    const first = words[0][0] ?? '';
    const last = words.length > 1 ? words[words.length - 1][0] ?? '' : '';
    return `${first}${last}`.toUpperCase();
  }
  @Input() matMenuTriggerData: any;
  @Input() matMenuTriggerFor: MatMenu;
  @Input() primary = false;
  @Input() text = '';
  @Output() buttonClick = new EventEmitter<void>();
}
